import React from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import { Tooltip } from 'components';
import styles from './MarkAsReadOrUnread.scss';

const MarkAsReadOrUnread = ({ markAsReadStyle, notification, staticTexts, onClickMarkAsRead }) => {
    const handleMarkAsReadOrUnread = (event) => {
        event.stopPropagation();
        onClickMarkAsRead(notification.id,!notification.seen)
    };

    return (
        <Tooltip title={ notification.seen ? staticTexts.markAsUnread : staticTexts.markAsRead }>
        <div
          className={classnames(styles.markAsRead, markAsReadStyle, { [styles.markAsUnread]: !notification.seen })}
          onClick={handleMarkAsReadOrUnread}
          data-testid={`alerts-popOver__mark-as-read-${notification.id}`}
          />
        </Tooltip> 
    )
};

MarkAsReadOrUnread.propTypes = {
    notification: PropTypes.shape({
      createdAt: PropTypes.string,
      type: PropTypes.string,
      seen: PropTypes.bool,
      data: PropTypes.object,
    }).isRequired,
    staticTexts: PropTypes.shape({
      markAsRead: PropTypes.string,
      markAsUnread: PropTypes.string,
    }).isRequired,
    onClickMarkAsRead: PropTypes.func.isRequired,
};  

export default MarkAsReadOrUnread;
